import React from 'react'
import axios from "axios";

// const EMPLOYEE_API_BASE_URL = "https://localhost:7116/api/";
const EMPLOYEE_API_BASE_URL = "https://apdea.xsnxt.com/api/";

class ClientService {
    // Fetch all data
    async GetAll(method) {
        try {
            const res = await axios.get(EMPLOYEE_API_BASE_URL + method)
                .then((response) => {
                    console.log(response);
                    return response;
                })
                .catch((error) => {
                    console.log(error);
                });
            return res;

        } catch (error) {
            console.log(`Error:${error?.response?.data}`);
        }
    }

    async CreateOrUpdate(method, data) {
        try {
            const res = await axios.post(EMPLOYEE_API_BASE_URL + method, data)
                .then((response) => {
                    console.log(response);
                    return response;
                })
                .catch((error) => {
                    console.log(error);
                })
            return res;

        } catch (error) {
            console.log(`Error:${error?.response?.data}`);

        }
    }

    async GetById(method, id) {
        try {
            const res = axios.get(EMPLOYEE_API_BASE_URL + method + id)
                .then((response) => {
                    console.log(response);
                    return response;
                }).catch((error) => {
                    console.log(error);
                })
            return res;
        } catch (error) {
            console.log(`Error:${error?.response?.data}`);
        }
    }

    async DeleteById(method, id) {
        try {
            const res = axios.delete(EMPLOYEE_API_BASE_URL + method + id)
                .then((response) => {
                    console.log(response);
                    return response;
                }).catch((error) => {
                    console.log(error);
                })
            return res;
        } catch (error) {
            console.log(`Error:${error?.response?.data}`);
        }
    }
}

export default new ClientService();
